(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name usuaris.main.controller:MainCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main')
    .controller('UsuarisMainCtrl', UsuarisMainCtrl);

  function UsuarisMainCtrl() {
    var vm = this;
    vm.ctrlName = 'UsuarisMainCtrl';
  }
}());
